import { __decorate } from "tslib";
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
let ListBox = class ListBox extends LitElement {
    constructor() {
        super(...arguments);
        this.disabled = false;
        this.label = '';
    }
    render() {
        return html `
            <label>
                ${this.label}
                <slot></slot>
            </label>`;
    }
};
ListBox.styles = css `
    :host{
        display: block;
    }
    label{
        display: block;
    }
    `;
__decorate([
    property({ type: Boolean, reflect: true })
], ListBox.prototype, "disabled", void 0);
__decorate([
    property({ type: String })
], ListBox.prototype, "label", void 0);
ListBox = __decorate([
    customElement("lit-opt-group")
], ListBox);
export { ListBox };
